import { ProductFilters } from "@/types";

export const PRODUCT_KEY = "PRODUCT";

export const PRODUCT_CACHE_KEYS = {
  LIST: (filters: ProductFilters) => [PRODUCT_KEY, "LIST", filters] as const,
  DETAIL: (id: string) => [PRODUCT_KEY, id] as const,
};
